import React, {useState} from 'react'
import {Trans} from '@lingui/macro'
import { TransProps } from '@lingui/react'
import {getColor} from 'components/utils'


// Type
export type typeInputFile = {
    variant?: string
    id: string
    name?: string
    accept?: string
    label?: React.ReactElement<TransProps>
    multiple?: boolean
    comment?: React.ReactElement<TransProps>
    required?: boolean
    labelClassName?: string

    onChange: (files: FileList | null) => void
}


// Component
export const InputFile:React.FC<typeInputFile> = ({
    variant,
    id,
    name,
    label,
    accept,
    comment,
    multiple= false,
    required=false,
    labelClassName,

    onChange,
}) => {

    const color = getColor(variant)

    const labelStyles = ['block mb-1 text-sm font-medium text-gray-700', labelClassName].join(' ')

    const [drag, setDrag] = useState(false)

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.files)
    }

    const dragStartHandler = (e: React.DragEvent<HTMLElement>) => {
        e.preventDefault()
        setDrag(true)
    }

    const dragLeaveHandler = (e: React.DragEvent<HTMLElement>) => {
        e.preventDefault()
        setDrag(false)
    }

    const onDropHandler = (e: React.DragEvent<HTMLElement>) => {
        e.preventDefault()
        setDrag(false)
        onChange(e.dataTransfer.files)
    }

    return(
        <>
            {label
                ? <label htmlFor={id} className={labelStyles}>{label}</label>
                : null
            }
            {drag

                ? <div
                    className={`max-w-lg h-40 flex flex-col justify-center px-6 pt-5 pb-6 border-2 border-${color}-600 border-dashed rounded-md text-center`}
                    onDragStart={(e) => dragStartHandler(e)}
                    onDragLeave={(e) => dragLeaveHandler(e)}
                    onDragOver={(e) => dragStartHandler(e)}
                    onDrop={(e) => onDropHandler(e)}
                >
                    <span className={`text-sm font-medium text-${color}-600`}><Trans>Place the file in this area.</Trans></span>
                </div>

                : <div
                    className={`max-w-lg h-40 flex flex-col justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md`}
                    onDragStart={(e) => dragStartHandler(e)}
                    onDragLeave={(e) => dragLeaveHandler(e)}
                    onDragOver={(e) => dragStartHandler(e)}
                >

                    <div className="text-sm text-gray-600 text-center">
                        <label
                            htmlFor={id}
                            className={`relative cursor-pointer rounded-md font-medium text-${color}-600 hover:text-${color}-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-${color}-500`}
                        >
                            <span className={'px-1'}><Trans>Upload a file</Trans></span>

                            <input
                                id={id}
                                accept={accept}
                                multiple={multiple}
                                required={required}
                                name={name}
                                type="file"
                                className="sr-only"
                                onChange={(e) => onChangeHandler(e)}
                            />

                        </label>

                        <span className="pl-1 ml-2"><Trans>or drag and drop</Trans>{comment ? <><br/>{comment}</> : null}</span>



                    </div>


                </div>
            }
        </>
    )
}
